var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('left-bar'),_c('section',{attrs:{"id":"MainContent"}},_vm._l((_vm.posts),function(post){return _c('main-post',{key:post.id,attrs:{"post":post}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }